import { resultArticle } from '../constants';

const initialState = {
  isFetching: false,
  fetched: false,
  resultList: []
};

export function widgetResultList(state = initialState, action) {
  switch (action.type) {
    case resultArticle.REQUEST:
      return {
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt };
    case resultArticle.RECEIVE:
      return {
        ...state,
        resultList: action.resultList,
        isFetching: false,
        fetched: true,
        totalHits: action.totalHits,
        lastUpdated: action.lastUpdated
      };
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/widgetResultList.reducer.js